import React, { useMemo } from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "../../../helpers/helpers";
import _ from "lodash";
import { Table } from "./table";
import { toJS } from "mobx";
import { TableHeader } from "./survey-summary";
import { useTranslation } from "react-i18next";
import { useTableVisibility } from "./use-table-visibility";
import { CompactAnalyticsTable } from "./level1cards";
import { HighlightsAnalyticsTable } from "./highlights-status- card";

export const SurveysBylevel1HL = observer((props) => {
    const { surveyResponseStore, userStore } = useStore();
    const { allSurveyResponsesSummary } = surveyResponseStore;
    const { t } = useTranslation("survey_management");
    const isVisible = useTableVisibility("surveys_by_level1_hl");

    const data = useMemo(
        () => toJS(allSurveyResponsesSummary)?.["by_piv_level1_hl"] || [],
        [allSurveyResponsesSummary]
    );

    const columns = useMemo(
        () => [
            {
                Header: t("level1"),
                accessor: "piv_level1",
                Footer: t("total"),
            },
            {
                Header: t("highlights"),
                accessor: "has-hl",
                Footer: surveyResponseStore.get_total_surveys(data, "has-hl"),
            },
            {
                Header: t("no_highlights"),
                accessor: "no-hl",
                Footer: surveyResponseStore.get_total_surveys(data, "no-hl"),
            },
            {
                Header: t("not_checked"),
                accessor: "not-checked",
                Footer: surveyResponseStore.get_total_surveys(data, "not-checked"),
            },
            {
                Header: t("total"),
                accessor: "total",
                Footer: surveyResponseStore.get_total_surveys(data, "total"),
            },
        ],
        [allSurveyResponsesSummary]
    );

    if (!isVisible) return null;
    if (!allSurveyResponsesSummary) return null;
    if (_.isEmpty(allSurveyResponsesSummary["by_qalog_user_status"]) || userStore.is_field_worker())
        return null;

    const row_click_handler = (x) => {
        surveyResponseStore.applyFilter("piv_level1", x["piv_level1"], `level1: ${x["piv_level1"]}`);
    };

    return (
        <div className="w-100 flex flex-col md:w-0">
            <TableHeader title={t("interviews_by_level_1")} />
            <Table data={data} columns={columns} onRowClick={row_click_handler} />
            {/*<HighlightsAnalyticsTable*/}
            {/*    data={data}*/}
            {/*    titleField="piv_level1"*/}
            {/*    titleHeader="Level 1"*/}
            {/*    pageSize={10}*/}
            {/*    onRowClick={row_click_handler}*/}
            {/*/>*/}
            {/*<CompactAnalyticsTable data={data} titleField="piv_level1" onRowClick={row_click_handler} />*/}
        </div>
    );
});
